import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxntLoadingSpinnerComponent } from './rxnt-loading-spinner.component';

@NgModule({
  declarations: [
    RxntLoadingSpinnerComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    RxntLoadingSpinnerComponent,
  ],
})
export class RxntLoadingSpinnerModule {
}
